import React, { useEffect, useRef, useState } from 'react';
import '../components/styles/Preloader.css';

const Preloader = ({
  auto = false,
  isComplete = false,
  onFinish,
  label = 'Cargando...',
  progressOverride,
}) => {
  const [progress, setProgress] = useState(progressOverride ?? 0);
  const hasFinished = useRef(false);

  useEffect(() => {
    if (typeof progressOverride === 'number') {
      setProgress(progressOverride);
      return undefined;
    }
    let interval;
    const target = auto ? 100 : isComplete ? 100 : 90;
    const step = auto ? 1 : isComplete ? 4 : 1;
    const delay = auto ? 15 : isComplete ? 16 : 28;

    interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= target) {
          clearInterval(interval);
          return prev;
        }
        return Math.min(prev + step, target);
      });
    }, delay);

    return () => clearInterval(interval);
  }, [auto, isComplete, progressOverride]);

  useEffect(() => {
    if (!auto && isComplete && progress >= 100 && !hasFinished.current) {
      hasFinished.current = true;
      onFinish?.();
    }
  }, [auto, isComplete, onFinish, progress]);

  useEffect(() => {
    if (!isComplete) {
      hasFinished.current = false;
    }
  }, [isComplete]);

  return (
    <div className="preloader">
      <div className="preloader-box">
        <div className="preloader-bar">
          <div className="preloader-progress" style={{ width: `${progress}%` }} />
        </div>
        <p className="preloader-text">
          {label} {Math.min(progress, 100).toFixed(0)}%
        </p>
      </div>
    </div>
  );
};

export default Preloader;
